export default {
    init: function () {
        // Get all navbar togglers
        const togglers = document.querySelectorAll('.navbar-toggler');

        // Add click event listener to each toggler
        togglers.forEach(toggler => {
            toggler.addEventListener('click', function() {
                // Find the navbar element
                const navbar = document.querySelector('.js-navbar');
                if (navbar) {
                    navbar.classList.toggle('is-open');
                }

                // Toggle the no-scroll class on the body
                document.body.classList.toggle('no-scroll');
            });
        });
    }
};
